import { render, staticRenderFns } from "./g-userInfo.vue?vue&type=template&id=67f0e53c&scoped=true"
import script from "./g-userInfo.vue?vue&type=script&lang=ts"
export * from "./g-userInfo.vue?vue&type=script&lang=ts"
import style0 from "./g-userInfo.vue?vue&type=style&index=0&id=67f0e53c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f0e53c",
  null
  
)

export default component.exports